import React from 'react';
import TextFieldComp from '../TextFieldComp';
import GridCenterItem from '../GridCenterItem';

function ChangePassSkeleton({
  OError,
  OHelp,
  OValue,
  changeOPass,
  handleEnter,
  inputStyles,
  NError,
  NHelp,
  NValue,
  changeNPass,
  CError,
  CHelp,
  CValue,
  changeConfPass,
}) {
  return (
    <>
      <GridCenterItem>
        <TextFieldComp
          name="OldPassword"
          label="Old Password *"
          placeholder="Old Password"
          error={OError}
          helpertext={OHelp}
          value={OValue}
          onChange={changeOPass}
          handleEnter={handleEnter}
          inputStyles={inputStyles}
          secure
          type="password"
        />
      </GridCenterItem>
      <GridCenterItem>
        <TextFieldComp
          name="NewPassword"
          label="New Password *"
          placeholder="New Password"
          error={NError}
          helpertext={NHelp}
          value={NValue}
          onChange={changeNPass}
          handleEnter={handleEnter}
          inputStyles={inputStyles}
          type="password"
        />
      </GridCenterItem>
      <GridCenterItem>
        <TextFieldComp
          name="ConfirmPassword"
          label="Confirm Password *"
          placeholder="Confirm Password"
          error={CError}
          helpertext={CHelp}
          value={CValue}
          onChange={changeConfPass ? changeConfPass : () => null}
          handleEnter={handleEnter}
          inputStyles={inputStyles}
          type="password"
        />
      </GridCenterItem>
    </>
  );
}

export default ChangePassSkeleton;
